import React from 'react';
import successCheck from '../../assets/successfullCheck.svg';
import warningCheck from '../../assets/warningCheck.svg';

/**
 * Status glyph icons for readiness checks.
 * pass/at_risk/fail use the design SVG assets; running/skipped stay drawn inline
 * (spinner uses SVG-native animateTransform — no CSS dependency).
 */
export default function StatusGlyph({ status, size = 18 }) {
  const s = size;
  const half = s / 2;

  switch (status) {
    case 'pass':
      return <img className="RkGlyph RkGlyph--pass" src={successCheck} width={s} height={s} alt="" aria-hidden="true" />;

    case 'fail':
    case 'at_risk':
      return <img className={`RkGlyph RkGlyph--${status}`} src={warningCheck} width={s} height={s} alt="" aria-hidden="true" />;

    case 'running':
      return (
        <svg width={s} height={s} viewBox={`0 0 ${s} ${s}`} aria-hidden="true" className="RkGlyph RkGlyph--running">
          <circle
            cx={half}
            cy={half}
            r={half - s * 0.1}
            fill="none"
            stroke="currentColor"
            strokeWidth={s * 0.1}
            strokeDasharray={`${(half - s * 0.1) * 1.6} ${(half - s * 0.1) * 4.7}`}
            strokeLinecap="round"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              from={`0 ${half} ${half}`}
              to={`360 ${half} ${half}`}
              dur="1s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      );

    case 'skipped':
    default:
      return (
        <svg width={s} height={s} viewBox={`0 0 ${s} ${s}`} aria-hidden="true" className="RkGlyph RkGlyph--skipped">
          <rect x={s * 0.15} y={half - s * 0.06} width={s * 0.7} height={s * 0.12} rx={s * 0.06} fill="currentColor" />
        </svg>
      );
  }
}
